import StoreService from '@topgeschenken/front-library/services/StoreService';

const BASE_ENDPOINT = '/order/orders';
const storeService = new StoreService(BASE_ENDPOINT);

const state = () => ({
  ...storeService.getState(),
});

const actions = {
  ...storeService.getActions(),

  // eslint-disable-next-line no-empty-pattern
  repeatOrder ({ }, { uuid }) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .create('', {
        uuid,
        action: 'copy-to-cart-order',
      });
  },
};

const mutations = {
  ...storeService.getMutations(),
};

const getters = {
  ...storeService.getGetters(),
};

export default {
  state,
  mutations,
  actions,
  getters,
};
